export default __webpack_public_path__ + "locales/it/FilesSettings.json?hash=d6021820428b7d689d50d5cd4521f969";